import { Injectable, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class LoaderService {

  private globalLoading = signal(false);
  private activeGlobalRequests = 0;

  private sectionLoaders = signal<Record<string, boolean>>({});
  private activeSectionRequests: Record<string, number> = {};

  isGlobalLoading = this.globalLoading.asReadonly();
  sectionLoadersState = this.sectionLoaders.asReadonly();

  showGlobal() {

    this.activeGlobalRequests++;
    this.globalLoading.set(true);
  }

  hideGlobal() {

    this.activeGlobalRequests = Math.max(0, this.activeGlobalRequests - 1);
    if (this.activeGlobalRequests === 0) {
      this.globalLoading.set(false);
    }
  }

  showSection(sectionId: string) {

    this.activeSectionRequests[sectionId] = (this.activeSectionRequests[sectionId] ?? 0) + 1;
    this.updateSectionLoader(sectionId);
  }

  hideSection(sectionId: string) {

    this.activeSectionRequests[sectionId] = Math.max(0, (this.activeSectionRequests[sectionId] ?? 0) - 1);
    this.updateSectionLoader(sectionId);
  }

  private updateSectionLoader(sectionId: string) {

    const current = { ...this.sectionLoaders() };
    current[sectionId] = (this.activeSectionRequests[sectionId] ?? 0) > 0;
    this.sectionLoaders.set(current);
  }

  isSectionLoading(sectionId: string) {

    return this.sectionLoaders()[sectionId] ?? false;
  }
}
